
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/setup",
      function () {
        return require("private-next-pages/setup/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/setup"])
      });
    }
  